<script>
export default {
    name: 'EightQueue',
    data() {
        return {
            board: []
        }
    },
    mounted() {
        this.initBoard()
    },
    methods: {
        initBoard() {
            this.board = []
            for (let i = 0; i < 8; i++) {
                let row = []
                for (let j = 0; j < 8; j++) {
                    row.push({key: i * 8 + j, ok: false})
                }
                this.board.push(row)
            }
        },
        onhover(cell, index, cellIndex) {
            for (let i = 0; i < 8; i++) {
                if (this.board[i][cellIndex].ok) {
                    cell.ok = false
                    return
                } 
            }
            for (let i = 0; i < 8; i++) {
                if (this.board[index][i].ok) {
                    cell.ok = false
                    return
                } 
            }
            for (let i = index + 1, j = cellIndex + 1; i < 8 && j < 8; i++, j++) {
                if (this.board[i][j].ok) {
                    cell.ok = false
                    return
                }
            }
            for (let i = index - 1, j = cellIndex - 1; i >= 0 && j >= 0; i--, j--) {
                if (this.board[i][j].ok) {
                    cell.ok = false
                    return
                }
            }
            for (let i = index + 1, j = cellIndex - 1; i < 8 && j >= 0; i++, j--) {
                if (this.board[i][j].ok) {
                    cell.ok = false
                    return
                }
            }
            for (let i = index - 1, j = cellIndex + 1; i >= 0 && j < 8; i--, j++) {
                if (this.board[i][j].ok) {
                    cell.ok = false
                    return
                }
            }
            cell.ok = true
        }
    }
}



</script>

<template>
  <div>
    <div class="title">八皇后问题</div>
    <button @click="initBoard">重新开始</button>
    <div class="board">
      <div class="row" v-for="(row, index) in board" :key="index">
        <div class="cell" v-for="(cell, cellIndex) in row" @click.stop="onhover(cell, index, cellIndex)" :key="cell.key" :class="{'queen': (index + cellIndex) % 2 == 0}">
            <div v-if="cell.ok" class="Q">Q</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<style scoped>
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
button {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  background-color: #ffffff;
  border: 1px solid #000000;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}
button:hover {
  background-color: #dddddd;
}
.board {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
}
.row {
  display: flex;
}
.cell {
  width: 50px;
  height: 50px;
  background-color: #f0f0f0;
  margin: 5px;
  cursor: pointer;
}
.queen {
  background-color: #dddddd;
}
.Q {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  text-align: center;
  line-height: 50px;
}

</style>